<template>
    <div>
        <d-table 
            class="bg-white shadow mt-10 mb-5" 
            :data="answers" 
            :columns="tableColumns"
            :loading="loading" 
            striped 
            detail-key="id">
            <template #default="{ row }">
                <td>{{ row.question }}</td>
                <td>{{ row.questionType }}</td>
                <td v-if="row.questionType === 'File Upload'">
                    <div v-for="fileName in row.fileNames" :key="fileName">
                        <a :href="'/api/subject-areas/content-listings/exam-reports/download-file/'+row.id + '?fileName='+encodeURIComponent(fileName)">
                            <u>{{ getCleanFileName(fileName) }}</u>
                        </a>
                    </div>
                </td>
                <td v-else>{{ row.answer }}</td>
                <td>{{ row.isCorrect }}</td>
            </template>
        </d-table>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        parent: true,

        props: {
            exam: {
                type: Object,
                default: () => ({}),
            },
        },

        data() {
            return {
                answers: [],
                loading: false,
                total: 0,
                pagination: {
                    page: 1,
                    pageSize: 500,
                    sortField: '',
                    sortOrder: '',
                },
                tableColumns: [
                    { field: 'question', label: 'Question', sortable: false },
                    { field: 'questionType', label: 'Type', sortable: false },
                    { field: 'answer', label: 'Answer', sortable: false },
                    { field: 'isCorrect', label: 'Is Correct', sortable: false }
                ]
            };
        },

        mounted() {
            this.getPaged();
        },

        methods: {
            async getPaged() {
                const {
                    page, pageSize,
                } = this.pagination;
                const params = [`currentPage=${page}`, `pageSize=${pageSize}`].join('&');
                this.loading = true;
                const { data } = await axios.get(`/api/subject-areas/content-listings/exam-reports/${this.exam.examId}/${this.exam.userId}/answers?${params}`);
                this.answers = data.resultItems;
                this.total = data.totalRecords;
                this.loading = false;
            },

            getCleanFileName(fileName) {
                // Decode URL encoding and extract just the filename part
                try {
                    const decoded = decodeURIComponent(fileName);
                    // Extract just the filename from the full path/URL
                    return decoded.split('/').pop().split('\\').pop();
                } catch (e) {
                    // If decoding fails, just extract the filename from the original
                    return fileName.split('/').pop().split('\\').pop();
                }
            }
        }
    };
</script>